import axios from "axios";
import ApiConstants from "../Utils/ApiConstant";
import SessionManager from "../Utils/Session";

const StateService = {
  get: async (offset, limit, searchQuery) => {
    try {
      const response = await axios.get(
        ApiConstants.state +
          `?offset=${offset}&limit=${limit}&searchQuery=${searchQuery.trim()}`
      );
      if (response.status === 200) {
        return response.data;
      } else {
        throw new Error(response.error);
      }
    } catch (error) {
      throw error;
    }
  },

  bulkUploadData: async (file) => {
    const formData = new FormData();
    formData.append("file", file)
    try {
      const response = await axios.post(ApiConstants.bulkUploadState, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
          Authorization: `Bearer ${SessionManager.shared.getSessionToken()}`,
        },
      });
      if (response.status === 200) {
        return response.data;
      } else {
        throw new Error(response.error);
      }
    } catch (error) {
      throw error;
    }
  },

  getAll: async () => {
    try {
      const response = await axios.get(ApiConstants.getAllStates);
      if (response.status === 200) {
        return response.data;
      } else {
        throw new Error(response.error);
      }
    } catch (error) {
      throw error;
    }
  },

  delete: async (id) => {
    try {
      const response = await axios.post(
        ApiConstants.deleteState,
        {
          id: id,
        },
        {
          headers: {
            Authorization: `Bearer ${SessionManager.shared.getSessionToken()}`,
          },
        }
      );
      if (response.status === 200) {
        return response.data;
      } else {
        throw new Error(response.error);
      }
    } catch (error) {
      throw error;
    }
  },

  changeStatus: async (id, status) => {
    try {
      const response = await axios.put(
        ApiConstants.changeStateStatus,
        {
          id: id,
          isActive: status,
        },
        {
          headers: {
            Authorization: `Bearer ${SessionManager.shared.getSessionToken()}`,
          },
        }
      );
      if (response.status === 200) {
        return response.data;
      } else {
        throw new Error(response.error);
      }
    } catch (error) {
      throw error;
    }
  },

  create: async (name) => {
    try {
      const response = await axios.post(
        ApiConstants.state,
        {
          name: name.trim(),
        },
        {
          headers: {
            Authorization: `Bearer ${SessionManager.shared.getSessionToken()}`,
          },
        }
      );
      if (response.status === 200) {
        return response.data;
      } else {
        throw new Error(response.error);
      }
    } catch (error) {
      throw error;
    }
  },

  update: async (id, name) => {
    try {
      const response = await axios.put(
        ApiConstants.state,
        {
          name: name.trim(),
          id: id,
        },
        {
          headers: {
            Authorization: `Bearer ${SessionManager.shared.getSessionToken()}`,
          },
        }
      );
      if (response.status === 200) {
        return response.data;
      } else {
        throw new Error(response.error);
      }
    } catch (error) {
      throw error;
    }
  },
};

export default StateService;
